import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

export default function WhyAbout({ about, why }) {
  return (
    <section id="about" data-testid="about-section" className="relative bg-slate-50 py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        {/* About */}
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <motion.div {...fadeUp} className="lg:col-span-6 order-2 lg:order-1">
            <span className="eyebrow">About NEEC Digital</span>
            <h2 className="mt-4 font-display font-bold text-navy tracking-tight text-3xl sm:text-4xl lg:text-[2.9rem] leading-[1.05]">
              {about?.title}
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">{about?.body}</p>
          </motion.div>
          <motion.div {...fadeUp} className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-tr from-brand-blue/20 to-brand-cyan/10 blur-2xl rounded-3xl" />
              <div className="relative overflow-hidden rounded-2xl border border-slate-200" style={{ clipPath: "polygon(8% 0, 100% 0, 100% 100%, 0 100%, 0 12%)" }}>
                <img src={about?.image} alt="NEEC Digital team" className="w-full h-[380px] object-cover" />
              </div>
            </div>
          </motion.div>
        </div>

        {/* Why / manifesto */}
        <div id="why-us" className="mt-28">
          <motion.div {...fadeUp} className="max-w-3xl">
            <span className="eyebrow">Why NEEC Digital</span>
            <h2 className="mt-4 font-display font-bold text-navy tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
              {why?.title}
            </h2>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">{why?.intro}</p>
          </motion.div>

          <div className="mt-14 grid md:grid-cols-2 gap-px bg-slate-200 rounded-2xl overflow-hidden border border-slate-200">
            {(why?.chapters || []).map((c, i) => (
              <motion.div
                key={c.number}
                data-testid={`manifesto-chapter-${c.number}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: (i % 2) * 0.08 }}
                className="group bg-white p-8 sm:p-10 hover:bg-navy transition-colors duration-500"
              >
                <div className="font-display text-5xl font-bold text-slate-200 group-hover:text-brand-blue transition-colors">{c.number}</div>
                <h3 className="mt-5 font-display text-xl font-semibold text-navy group-hover:text-white transition-colors">{c.title}</h3>
                <p className="mt-3 text-slate-500 leading-relaxed group-hover:text-slate-300 transition-colors">{c.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
